import { useSubscriptionEligibleTo } from "@hooks/use-current-user";
import DrawerUnlockEarlyTunnel from "../DrawerUnlockEarlyTunnel";
import DrawerReceivedNoNextClosetNoUnlockEarly from "./DrawerReceivedNoNextClosetNoUnlockEarly";
import DrawerEligibleToNextCloset from "./DrawerEligibleToNextCloset";

function DrawerClosetReceived() {
  const subscriptionEligibleTo = useSubscriptionEligibleTo();

  if (subscriptionEligibleTo === "next_closet") return <DrawerEligibleToNextCloset />;
  if (subscriptionEligibleTo === "unlock_early") return <DrawerUnlockEarlyTunnel />;

  return <DrawerReceivedNoNextClosetNoUnlockEarly />;
}

export default DrawerClosetReceived;
